import React, { useState, useEffect } from "react";
import { Card, Grid, Typography } from "@mui/material";
import partner from "../../../assets/images/partner.png";
import screen from "../../../assets/images/screen.png";
import "./YourWish.scss";
import { useNavigate } from "react-router-dom";
import { getStatusQuo } from "../../../services/yourWishes";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
const YourWish = () => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [data, setData] = useState(false);
  const fetchData = async () => {
    const result = await getStatusQuo(uID);
    if (result?.payLoad?.length) {
      setData(result.payLoad.some((element) => element.isWishChecked));
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const navigate = useNavigate();
  return (
    <Card className="your-wish">
      <Grid container py="60px">
        <Grid item lg={11} md={10} sm={12} xs={12} className="outer-grid">
          <Typography variant="h5" fontWeight={"bolder"} color={"#262B3E"}>
            {t("sidebar-2-text-2")}
          </Typography>
          <Typography className="description">
            {t("your-wish-heading-2")}
          </Typography>
          <Grid container width="70%">
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Card
                className="grid-card-1"
                sx={{
                  borderRadius: 4,
                  ml: { lg: 5, md: 2, sm: 0, xs: 2 },
                  mb: { lg: 0, md: 2, sm: 2, xs: 2 },

                  boxShadow: "4px 4px 6px 3px rgba(119,136,153,0.15)",
                  webkitBoxShadow: "4px 4px 6px 3px rgba(119,136,153,0.15)",
                  mozBoxShadow: "4px 4px 6px 3px rgba(119,136,153,0.15)",
                }}
                onClick={() => {
                  navigate("/appointment");
                }}
              >
                <div className="img-div">
                  <img src={partner} width="45px" height="55px" />
                </div>
                <div className="card-text">
                  <div>
                    <span>{t("fill-document")}</span>
                    <p>{t("fill-document-type-1")}</p>
                  </div>
                </div>
              </Card>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Card
                className="grid-card-2"
                onClick={() => {
                  if (data) {
                    navigate("/documents");
                  } else {
                    toast.error(t("select-wishes"));
                  }
                }}
                sx={{
                  borderRadius: 4,
                  ml: { lg: 3, md: 2, sm: 0, xs: 2 },
                  mr: { lg: 2, md: 2, sm: 0, xs: 2 },
                  mb: { lg: 0, md: 2, sm: 2, xs: 2 },

                  boxShadow: "4px 4px 6px 3px rgba(119,136,153,0.15)",
                  webkitBoxShadow: "4px 4px 6px 3px rgba(119,136,153,0.15)",
                  mozBoxShadow: "4px 4px 6px 3px rgba(119,136,153,0.15)",
                }}
              >
                <div className="img-div">
                  <img src={screen} width="50px" height="50px" />
                </div>
                <div className="card-text">
                  <div style={{ textAlign: "center" }}>
                    <span>{t("fill-document")}</span>
                    <p>{t("fill-document-type-2")}</p>
                  </div>
                </div>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default YourWish;
